<template>
  <v-form class="mb-3" autocomplete="off" @submit.prevent="">
    <v-row class="filters" align="center" justify="start">
      <v-col class="mt-0 pt-0 pr-11">
        <v-row class="mt-3">
          <v-col cols="12" sm="6" class="pb-0">
            <v-text-field
              v-model.trim="filters.searchTerm"
              label="Sériové číslo, název, zákazník"
              outlined
              dense
              background-color="white"
              append-icon="mdi-magnify"
              hide-details
              :prepend-icon="filters.searchTerm ? 'mdi-close' : 'mdi-none'"
              @click:append="filter"
              @click:prepend.prevent="removeFromFilter('searchTerm')"
              @keydown.enter="filter()"
            />
          </v-col>
          <v-col cols="12" sm="6" class="pb-0">
            <v-text-field
              v-model.trim="filters.searchTermAlert"
              label="Zpráva, upozornění"
              outlined
              dense
              background-color="white"
              append-icon="mdi-magnify"
              hide-details
              :prepend-icon="filters.searchTermAlert ? 'mdi-close' : 'mdi-none'"
              @click:append="filter"
              @click:prepend.prevent="removeFromFilter('searchTermAlert')"
              @keydown.enter="filter()"
            />
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="12" sm="6" class="pb-0">
            <VAutocompleteWithValidation
              v-model="filters.types"
              label="Typ tiskárny"
              outlined
              dense
              hide-details
              background-color="white"
              item-text="text"
              item-value="name"
              :items="types"
              :loading="typesLoading"
              :icon="filters.types ? 'mdi-close' : 'mdi-none'"
              @click:prepend="filters.types = null"
              @keydown.enter="filter()"
            />
          </v-col>
        </v-row>
        <v-row v-if="!customer">
          <v-col
            cols="12"
            sm="6"
          >
            <v-checkbox
              style="margin-top: -16px"
              class="px-8"
              v-model="filters.idle"
              :label="'Nečinné tiskárny >= ' + getTime(setting.statusIdle) + ''"
              color="primary"
              @change="filter()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
            <v-checkbox
              :style="customer ? 'margin-top: -16px' : 'margin-top: -32px'"
              class="px-8"
              v-model="filters.lowToner"
              label="Nízký stav toneru"
              color="primary"
              @change="filter()"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="pt-0 pr-11 pb-6 text-right">
        <v-btn depressed height="40px" min-width="130px" outlined @click="resetFilter">
          Zrušit filtr
        </v-btn>

        <v-btn
          depressed
          height="40px"
          min-width="130px"
          color="primary"
          class="ml-4"
          @click="filter"
        >
          Filtrovat
        </v-btn>
      </v-col>
    </v-row>
  </v-form>

</template>

<script>
import { mapActions } from 'vuex';
import VAutocompleteWithValidation from '@/components/validators/VAutocompleteWithValidation.vue';

export default {
  name: 'PrintersFilters',
  components: { VAutocompleteWithValidation },
  props: {
    customer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {
        searchTerm: null,
        searchTermAlert: null,
        idle: null,
        lowToner: null,
        types: null,
      },
      setting: {
        statusIdle: 0,
      },
      settingLoading: false,
      types: [
        {
          name: 'CANON',
          text: 'Canon',
        },
        {
          name: 'BROTHER',
          text: 'Brother',
        },
        {
          name: 'EPSON',
          text: 'Epson',
        },
        {
          name: 'GENERIC',
          text: 'Obecná',
        },
      ],
      typesLoading: false,
    };
  },
  methods: {
    ...mapActions({
      getSetting: 'setting/getSetting',
    }),
    filter() {
      const filters = {
        ...this.filters,
      };
      this.$emit('filter', filters);
    },
    removeFromFilter(removingFilter) {
      this.filters[removingFilter] = null;
      this.filter();
    },
    resetFilter() {
      Object.keys(this.filters).forEach((filter) => {
        this.filters[filter] = null;
      });
      this.$emit('filter', this.filters);
    },
    setFilter() {
      if (Object.values(this.$route.query)) {
        Object.entries(this.$route.query).forEach((keyValue) => {
          const [key, value] = keyValue;
          if (key !== 'searchTerm' && key !== 'searchTermAlert') {
            this.filters[key] = Number(value) || value;
          } else {
            this.filters[key] = value;
          }
        });
      }
    },
    getTime(minutes) {
      const seconds = minutes * 60;
      const d = Math.floor(seconds / (3600 * 24));
      const h = Math.floor((seconds % (3600 * 24)) / 3600);
      const m = Math.floor((seconds % 3600) / 60);

      return `${this.getValue(d, 'd')} ${this.getValue(h, 'h')} ${this.getValue(m, 'm')}`;
    },
    getValue(value, unit) {
      if (value === 0) return '';
      return `${value}${unit}`;
    },
    loadSetting() {
      this.settingLoading = true;
      this.getSetting()
        .then((response) => {
          this.setting = response.data;
        })
        .finally(() => {
          this.settingLoading = false;
        });
    },
  },
  created() {
    this.setFilter();
    if (!this.customer) {
      this.loadSetting();
    }
  },
};
</script>
